import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Spinner } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { UserContext } from '../../App';
import Payment from '../Payment/Payment';
import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
import './CheckOutPage.css';

const CheckOutPage = (props) => {

    return (
        <div>
            <Payment></Payment>
        </div>
    );
};

export default CheckOutPage;